import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStableVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStableVoice"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.42969 17H11.2305V7H9.42969V17ZM12.7598 15H14.5605V9H12.7598V15ZM6.09961 14H7.90039V10H6.09961V14ZM16.0996 10V14H17.9004V10H16.0996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStableVoice;
